<template>
  <div>
    <div class="series-bar section">
      <div class="tit">
        <i class="jour1"></i>
        系列分类
        <i class="jour1-right"></i>
      </div>
      <ul>
        <li
          @click="change(elem, i)"
          v-for="(elem, i) of list"
          :key="i"
          :class="listValue == elem ? 'li-active' : ''"
        >
          {{ elem }}
        </li>
      </ul>
    </div>
    <div class="series-bar">
      <div class="tit">
        <i class="jour2"></i>
        学科分类
        <i class="jour1-right"></i>
      </div>
      <ul>
        <li
          @click="change1(elem, i)"
          v-for="(elem, i) of list2"
          :key="i"
          :class="[
            listValue2 == elem.subjectName && !elem.child ? 'li-active' : '',
            elem.subjectName == listValue2 && elem.child ? 'haschild' : '',
          ]"
          ref="offset"
        >
          {{ elem.subjectName }}
          <i :class="elem.child ? 'el-icon-plus' : ''"></i>
        </li>
        <div
          :style="{
            top: layerY + 36 + 'px',
            height: secList.length > 0 ? '80px' : 0,
          }"
          class="sec"
        >
          <span
            @click="change2(elem, i)"
            :class="listValue2sec == elem.subjectName ? 'sec-active' : ''"
            v-for="(elem, i) of secList"
            :key="i"
            >{{ elem.subjectName }}</span
          >
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listValue: "所有系列",
      list: [
        "所有系列",
        "中华系列",
        "中国系列",
        "国际系列",
        "电子版",
        "出版平台合作期刊",
        "英文系列",
      ],
      list2: [],
      listValue2: "所有学科",
      listValue2sec: "",
      secList: [],
      layerY: 0,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      // this.$api.perioSub().then((res) => {
      //   console.log(res);
      //   this.list2 = res.data.data;
      //   this.list2.unshift({
      //     subjectName: "所有学科",
      //     id: 0,
      //   });
      //   console.log(this.list2);
      // });
    },
    change(elem, i) {
      console.log(this.$refs);
      this.listValue = elem;
      this.$emit("type", { name: elem, id: i });
    },
    change1(elem, i) {
      if (elem.child) {
        this.layerY = this.$refs.offset[i].offsetTop;
        this.secList = elem.child;
        this.listValue2 = elem.subjectName;
      } else {
        this.listValue2 = elem.subjectName;

        this.secList = [];
        this.$emit("type2", { name: elem.subjectName, id: elem.id });
      }
    },
    change2(elem, i) {
      this.listValue2sec = elem.subjectName;
      this.$emit("type2", { name: elem.subjectName, id: elem.id });
    },
  },
};
</script>

<style scoped>
.section {
  position: relative;
}
.section::before {
  content: "";
  display: block;
  width: 30px;
  height: 1px;
  background-color: #02354b;
  position: absolute;
  left: 0;
  bottom: -1px;
  z-index: 9;
}
.section::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background-color: #ddd;
  position: absolute;
  left: 0;
  bottom: -1px;
}
.series-bar {
  /*  */
  position: relative;
  padding: 15px 0 4px;
  display: flex;
  justify-content: space-between;
}
.series-bar > .tit {
  width: 200px;
  height: 54px;
  line-height: 22px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 14px 20px 14px 0;
  /* background-color: #52b8cc; */
  cursor: pointer;
  line-height: 36px;
  font-size: 18px;
  font-weight: 700;
  color: #02354b;
  margin: 0;
}
.series-bar > .tit > .jour1 {
  display: inline-block;
  margin-right: 10px;
  width: 18px;
  height: 18px;
  background: url("../../assets/img/qklb.png") no-repeat -2px -1px;
  vertical-align: middle;
}
.series-bar > .tit > .jour2 {
  display: inline-block;
  margin-right: 10px;
  width: 18px;
  height: 18px;
  background: url("../../assets/img/qklb.png") no-repeat -2px -74px;
  vertical-align: middle;
}
.series-bar > .tit > .jour1-right {
  display: inline-block;
  margin-left: 20px;
  width: 9px;
  height: 1px;
  background: url("../../assets/img/qklb.png") no-repeat -2px -48px;
  vertical-align: middle;
  transform: scale(2);
}
.series-bar > ul {
  position: relative;
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  width: 980px;
  font-size: 15px;
  margin: 0;
  margin-top: 15px;
  padding: 2px 0;
  list-style: none;
}
.series-bar > ul > li {
  display: block;
  padding: 0 20px;
  margin: 0 23px 7px 20px;
  cursor: pointer;
  height: 34px;
  line-height: 34px;
  color: #606266;
}
.haschild {
  background: url("../../assets/img/s_PeriodicalList_select_hasChild_on.png")
    no-repeat bottom;
  margin-bottom: 80px !important;
}

.li-active,
.series-bar > ul > li:hover {
  background-color: #e4ecef;
  color: #52b8cc;
}
.sec {
  transition: 0.3s;
  background: #f8f9fa;
  position: absolute;
  left: 20px;
  height: 80px;
  width: 900px;
}
.sec > span {
  display: inline-block;
  padding: 0 20px;
  margin: 0 30px 7px 20px;
  cursor: pointer;
  height: 34px;
  line-height: 34px;
  color: #606266;
}
.sec-active,
.series-bar > ul > .sec > span:hover {
  background-color: #e4ecef;
  color: #52b8cc;
}
</style>